<template>
    <div>
        <drowning-header></drowning-header>
        <footer-view></footer-view>
    </div>
</template>

<script>
    import DrowningHeader from "../../components/drowning/DrowningHeader";
    import FooterView from "../FooterView";
    export default {
        name: "DrowningView",
        components: {FooterView, DrowningHeader}
    }
</script>

<style scoped>

</style>